type DocWithNameAndId = {
  name?: string | null;
  id?: string;
};

export function getDownloadFilename(
  doc: DocWithNameAndId,
  defaultExtension = 'pdf'
): string {
  const base =
    (doc.name ?? doc.id ?? 'document').replace(/[<>:"/\\|?*]/g, '_').trim() ||
    'document';
  const hasExtension = /\.[a-z0-9]+$/i.test(base);
  return hasExtension ? base : `${base}.${defaultExtension}`;
}
